import type { HiveIntegration, IntegrationCategory } from "@/types";

/**
 * Display metadata for the Integration Center. The integration records
 * themselves live server-side (per-org registry + connector catalogue) and are
 * hydrated through the API — see useHive.hydrate() and loadCatalog().
 */

export const INT_CATEGORIES: ("All" | IntegrationCategory | "Admin Managed")[] = [
  "All",
  "Communication",
  "Source Control",
  "Project Management",
  "Cloud",
  "CI/CD",
  "Observability",
  "Knowledge",
  "Security",
  "AI/Inference",
  "Data & Analytics",
  "Design",
  "Support & CRM",
  "Productivity",
  "Commerce & Billing",
  "Admin Managed",
];

export const INT_STATUS_LABEL: Record<HiveIntegration["status"], string> = {
  connected: "Connected",
  "not-connected": "Not Connected",
  pending: "Pending Auth",
  "needs-reauth": "Needs Reauth",
  "admin-managed": "Admin Managed",
  degraded: "Degraded",
};

export const INT_STATUS_TONE: Record<HiveIntegration["status"], string> = {
  connected: "connected",
  "not-connected": "queued",
  pending: "syncing",
  "needs-reauth": "degraded",
  "admin-managed": "internal",
  degraded: "degraded",
};

export const INT_HEALTH_LABEL: Record<HiveIntegration["health"], string> = {
  healthy: "Healthy",
  delayed: "Delayed",
  "rate-limited": "Rate Limited",
  "reauth-required": "Reauth Required",
  "permission-missing": "Permission Missing",
  "webhook-failed": "Webhook Failed",
  "admin-locked": "Admin Locked",
};

/** Auth style shown on catalogue cards and the connect form. */
export const AUTH_KIND_LABEL: Record<NonNullable<HiveIntegration["authKind"]>, string> = {
  oauth: "OAuth / access token",
  "api-key": "API key",
  token: "Access token",
  webhook: "Webhook",
  none: "No credentials",
};

export const REQUEST_REASONS = [
  "Needed for workspace",
  "Needed for task automation",
  "Needed for ARES",
  "Needed for BYONC routing",
  "Other",
];
